module.exports = __webpack_public_path__ + "static/media/partners.af816cb2.png";